import Vue from "vue";
import Router from "vue-router";
import {
	getCookie,
	getStorage,
	GetUrlParam,
	removeStorage,
} from "../utils/common";
import { routesArr } from "../utils/routeConfig";
import { comeOther, publicLogin } from "../utils/routerFun";


Vue.use(Router);
// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
	return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
	mode: "history", //history设置
	routes: routesArr
});


router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		if (to.meta.title === '购买知识套餐') {
			to.query.r ? to.meta.title = '领取知识套餐' : to.meta.title = '购买知识套餐'
		}
		document.title = to.meta.title
	}
	if (from.path !== '/address' && from.path !== '/createOrder') {
		removeStorage('chooseCouponResult')
	}
	// 如果地址栏有come字段 则是其它项目用了该页面
	if (to.query?.come) {
		comeOther(to, next)
		return
	}
	if (to.meta.isLogin || to.query?.r) { // 需要登录
		if (getStorage('cancelLogin')) {
			next()
			return
		}
		if (getStorage('liveuser') && getCookie('t')) {
			// refer()
		}
		if (GetUrlParam('code') && !(getStorage('liveuser') && getCookie('t'))) {
			publicLogin()
			return
		}
		if (!(getStorage('liveuser') && getCookie('t'))) {
			console.log('fullPath', "https://" + location.host + to.fullPath);
			if(to.fullPath.includes('risk')) {
				next()
			} else {
				next({
					path: '/login',
					query: {
						url: "https://" + location.host + to.fullPath,
					}
				})
			}
			
			return
		}
		next()
	} else {
		next()
	}
});

router.afterEach(() => {
	window.scrollTo(0, 0);
});

router.onError((error) => {
	const jsPattern = /Loading chunk (\S)+ failed/g
	const cssPattern = /Loading CSS chunk (\S)+ failed/g
	const isChunkLoadFailed = error.message.match(jsPattern || cssPattern)
	const targetPath = router.history.pending.fullPath
	if (isChunkLoadFailed) {
		localStorage.setItem('targetPath', targetPath)
		window.location.reload()
	}
});

router.onReady(() => {
	const targetPath = localStorage.getItem('targetPath')
	const tryReload = localStorage.getItem('tryReload')
	if (targetPath) {
		localStorage.removeItem('targetPath')
		if (!tryReload) {
			router.replace(targetPath)
			localStorage.setItem('tryReload', true)
		} else {
			localStorage.removeItem('tryReload')
		}
	}
})


export default router;
